<re-captcha [siteKey]="key"
            #captchaRef="reCaptcha"
            size="invisible"
            (resolved)="$event && handleResponse($event)">
</re-captcha>
